/**
 * A handle, and the profile behind it (owner, 2026-08-25).
 *
 * Nob's identities ARE X identities — the sign-in is X's and the handle on a
 * door is the one X issued. So a `@handle`
 * printed on a screen and not clickable was a dead end in the one place a
 * recipient most wants to look something up: deciding whether the stranger at
 * the door is worth ten minutes. Every surface that NAMES a counterpart now
 * links it.
 *
 * ONE COMPONENT so the rules cannot drift between the four places that print a
 * handle: a new tab (this app is a conversation the owner is in the middle of,
 * and navigating away from it loses their place), `noopener noreferrer` so the
 * opened page can neither reach back through `window.opener` nor be told where
 * the reader came from, and NO TRACKING PARAMETERS — the URL is exactly
 * `x.com/<handle>` and nothing is appended to it, because a referral tag on a
 * link a recipient followed to vet somebody would be us monetising their
 * caution.
 */

/** The canonical profile URL. Bare — a leading `@` is stripped, nothing added. */
export function xProfileUrl(handle: string): string {
  return `https://x.com/${handle.replace(/^@+/, "")}`;
}

export function XHandleLink({ handle, className = "" }: { handle: string; className?: string }) {
  const bare = handle.replace(/^@+/, "");
  return (
    <a
      href={xProfileUrl(bare)}
      target="_blank"
      rel="noopener noreferrer"
      // The label says where it goes: "@maya" alone, read aloud out of context,
      // is not a destination.
      aria-label={`@${bare} on X`}
      className={`hover:text-text hover:underline underline-offset-2 focus-visible:outline-none
                  focus-visible:ring-2 focus-visible:ring-focus/70 focus-visible:ring-offset-2
                  focus-visible:ring-offset-bg ${className}`}
    >
      @{bare}
    </a>
  );
}
